// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LightmodeIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="LightmodeIcon" ref={forwardedRef} {...props}>
      <path d="M11 2v2.5H9.5V2z" />
      <path d="m16.75 4.75-1.768 1.768-1.06-1.06 1.767-1.769z" />
      <path d="M11 18v-2.5H9.5V18z" />
      <path d="M2 9.5h2.5V11H2z" />
      <path d="M18 11V9.5h-2.5V11z" />
      <path d="m4.75 3.75 1.768 1.768-1.06 1.06-1.769-1.767z" />
      <path d="M5.518 13.982 3.75 15.75l1.06 1.06 1.768-1.767z" />
      <path d="m15.75 16.75-1.768-1.768 1.06-1.06 1.769 1.767z" />
      <path d="M14 10a4 4 0 1 1-8 0 4 4 0 0 1 8 0m-1.5 0a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const LightmodeIcon = /* @__PURE__ */ Object.assign(
  LightmodeIconComponent,
  { displayName: 'LightmodeIcon' },
);
